/* Prediction AI — refonte 2026. Comportements des sections pai-*. */
(function () {
  'use strict';

  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data || {});
      }
    } catch (e) { /* mesure facultative */ }
  }

  /* Redirection selon le pays (adresse IP détectée par Shopify), une seule fois par visiteur.
     Uniquement depuis la version française par défaut ; jamais pour les robots d'indexation,
     ni si le visiteur a déjà choisi sa langue ou arrive sur une version linguistique précise. */
  var GEO_KEY = 'pai-geo';
  var GEO_MAP = { IT: '/it-it', ES: '/es-es', GR: '/el-gr', CY: '/el-gr', GB: '/en-gb', KE: '/en-en', PL: '/pl' };
  var FRENCH_COUNTRIES = ['FR', 'BE', 'LU', 'CH', 'MC', 'RE', 'GP', 'MQ', 'GF', 'YT', 'PM', 'NC', 'PF', 'WF', 'BL', 'MF'];
  function geoGet() { try { return localStorage.getItem(GEO_KEY) || (document.cookie.match(/(?:^|; )pai_geo=([^;]+)/) || [])[1]; } catch (e) { return 'off'; } }
  function geoSet(v) {
    try { localStorage.setItem(GEO_KEY, v); } catch (e) { /* stockage indisponible */ }
    document.cookie = 'pai_geo=' + v + '; path=/; max-age=31536000; SameSite=Lax';
  }
  function initGeoRedirect() {
    // Tout choix de langue manuel est respecté ensuite.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'language_code') geoSet('chosen');
    });
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root !== '/' || geoGet()) return;
    if (/bot|crawl|spider|slurp|lighthouse|headless|preview/i.test(navigator.userAgent) || navigator.webdriver) return;
    if (window.Shopify && Shopify.designMode) return;
    var url = '/browsing_context_suggestions.json?country%5Benabled%5D=true';
    fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var country = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (!country) return;
        var browserLang = (navigator.language || '').slice(0, 2).toLowerCase();
        // Un francophone à l'étranger (navigateur en français) garde la version française.
        if (browserLang === 'fr') { geoSet('fr'); return; }
        var target = GEO_MAP[country];
        if (!target) {
          if (FRENCH_COUNTRIES.indexOf(country) !== -1 || browserLang === 'fr') { geoSet('fr'); return; }
          target = '/en';
        }
        geoSet('done');
        window.location.replace(target + window.location.pathname + window.location.search + window.location.hash);
      })
      .catch(function () { /* détection indisponible : on reste sur la version actuelle */ });
  }
  initGeoRedirect();

  /* Liens internes saisis « en dur » (ex. /products/…) : sur une version étrangère (/es-es/, /pl/…),
     on ajoute le préfixe de langue pour que le visiteur reste dans sa langue. */
  function storeRoot() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }
  var LOCALE_PREFIX =/^\/[a-z]{2}(-[a-z]{2})?(\/|$|\?|#)/i;
  var NO_LOCALE = /^\/(cdn|checkouts?|apps|a|tools|services|admin|wpm|web-pixels)(\/|$)/i;
  function localizePath(href) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root === '/' || !href || href.charAt(0) !== '/' || href.charAt(1) === '/') return null;
    if (LOCALE_PREFIX.test(href) || NO_LOCALE.test(href)) return null;
    var prefix = root.replace(/\/$/, '');
    return href === '/' ? prefix : prefix + href;
  }
  function localizeLink(a) {
    var fixed = localizePath(a.getAttribute('href'));
    if (fixed) a.setAttribute('href', fixed);
  }
  function initLocalizeLinks() {
    document.querySelectorAll('a[href^="/"]').forEach(localizeLink);
    // Liens ajoutés plus tard (menus, fenêtres) : corrigés au moment du clic.
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href^="/"]');
      if (a) localizeLink(a);
    }, true);
  }

  /* Apparition discrète des blocs */
  function initReveal() {
    var els = document.querySelectorAll('.pai-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Menu mobile */
  function initDrawer() {
    var btn = document.querySelector('[data-pai-burger]');
    var drawer = document.getElementById('PaiDrawer');
    if (!btn || !drawer) return;
    var iconOpen = btn.querySelector('[data-icon-open]');
    var iconClose = btn.querySelector('[data-icon-close]');
    function setOpen(open) {
      drawer.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (iconOpen) iconOpen.hidden = open;
      if (iconClose) iconClose.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }
    btn.addEventListener('click', function () { setOpen(drawer.hidden); });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) { setOpen(false); btn.focus(); }
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (mq) {
      if (mq.matches) setOpen(false);
    });
  }

  /* Mesure des clics sur les boutons d'action */
  function initCtaTracking() {
    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-pai-cta]');
      if (!el) return;
      track('pai_cta_click', { location: el.getAttribute('data-pai-cta'), label: (el.textContent || '').trim() });
    });
    var pricing = document.getElementById('tarifs');
    if (pricing && 'IntersectionObserver' in window) {
      var seen = false;
      var io = new IntersectionObserver(function (entries) {
        if (!seen && entries[0].isIntersecting) {
          seen = true;
          track('pai_pricing_view', {});
          io.disconnect();
        }
      }, { threshold: 0.3 });
      io.observe(pricing);
    }
  }

  /* Abonnement : même logique panier que la page produit actuelle */
  function initPlans() {
    var buttons = document.querySelectorAll('[data-pai-plan]');
    if (!buttons.length) return;
    var processing = false;

    /* Certaines applications (abonnements, notifications) remplacent window.fetch et retirent
       le plan d'abonnement des ajouts au panier. On utilise un fetch natif, non modifié,
       obtenu depuis une iframe vide du même domaine. */
    var cleanFetch = null;
    function nativeFetch(path, options) {
      if (!cleanFetch) {
        try {
          var frame = document.createElement('iframe');
          frame.setAttribute('aria-hidden', 'true');
          frame.tabIndex = -1;
          frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
          document.body.appendChild(frame);
          cleanFetch = frame.contentWindow.fetch.bind(frame.contentWindow);
        } catch (e) {
          cleanFetch = window.fetch.bind(window);
        }
      }
      // Préfixe de langue (/es-es/, /pl/…) : le panier, puis le paiement, restent dans la langue du visiteur.
      return cleanFetch(window.location.origin + storeRoot() + path.replace(/^\//, ''), options);
    }

    function fetchCart() {
      return nativeFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
    }
    function addPlan(plan) {
      var body = { id: Number(plan.variantId), quantity: 1 };
      if (plan.sellingPlanId) body.selling_plan = Number(plan.sellingPlanId);
      return nativeFetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
    }
    function changeLine(key, quantity) {
      return nativeFetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); });
    }
    function matches(item, plan) {
      var sp = (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) ||
        (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan_id) || item.selling_plan_id || null;
      var sameVariant = Number(item.id) === Number(plan.variantId);
      var sameSp = plan.sellingPlanId ? Number(sp) === Number(plan.sellingPlanId) : true;
      return sameVariant && sameSp;
    }
    async function dedupe(plan) {
      var cart = await fetchCart();
      var found = (cart.items || []).filter(function (it) { return matches(it, plan); });
      for (var i = 1; i < found.length; i++) {
        if (found[i].key) await changeLine(found[i].key, 0);
      }
      return found.length >= 1;
    }
    function goNext(btn) {
      var local = (btn.getAttribute('data-local-countries') || '').split(',');
      var country = btn.getAttribute('data-country') || 'FR';
      var root = storeRoot();
      window.location.href = (root !== '/' || local.indexOf(country) !== -1) ? root + 'checkout' : (btn.getAttribute('data-fallback-url') || '/cart');
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', async function (e) {
        e.preventDefault();
        if (processing) return;
        var plan = { variantId: btn.getAttribute('data-variant-id'), sellingPlanId: btn.getAttribute('data-selling-plan-id') };
        var errorEl = btn.parentElement.querySelector('.pai-plan__error');
        if (!plan.variantId) return;
        processing = true;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        if (errorEl) errorEl.textContent = '';
        track('pai_plan_select', { plan: btn.getAttribute('data-pai-plan') });
        try {
          var already = await dedupe(plan);
          if (!already) {
            await addPlan(plan);
            await dedupe(plan);
          }
          goNext(btn);
        } catch (err) {
          if (errorEl) errorEl.textContent = btn.getAttribute('data-error') || 'Une erreur est survenue. Réessayez.';
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          processing = false;
        }
      });
    });
    /* Retour arrière depuis le paiement : réactiver les boutons */
    window.addEventListener('pageshow', function () {
      processing = false;
      buttons.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
    });
  }

  /* Sélecteur d'offre : recopie l'offre choisie sur le bouton d'abonnement */
  function initPlanPicker() {
    document.querySelectorAll('[data-pai-picker]').forEach(function (picker) {
      var btn = picker.querySelector('[data-pai-plan]');
      if (!btn) return;
      function apply(input) {
        if (!input) return;
        btn.setAttribute('data-variant-id', input.getAttribute('data-variant-id') || '');
        btn.setAttribute('data-selling-plan-id', input.getAttribute('data-selling-plan-id') || '');
        btn.setAttribute('data-pai-plan', input.value);
        var label = btn.querySelector('[data-pai-plan-label]');
        if (label && input.getAttribute('data-button-label')) label.textContent = input.getAttribute('data-button-label');
      }
      picker.addEventListener('change', function (e) {
        if (e.target.matches('input[type="radio"]')) apply(e.target);
      });
      apply(picker.querySelector('input[type="radio"]:checked'));
    });
  }

  /* Galerie : vignettes qui changent l'image principale */
  function initGallery() {
    document.querySelectorAll('[data-pai-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-pai-gallery-main]') || gallery.querySelector('.pai-gallery__main img');
      var thumbs = gallery.querySelectorAll('[data-pai-thumb]');
      if (!main) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          main.src = thumb.getAttribute('data-src');
          main.alt = thumb.getAttribute('data-alt') || '';
          if (thumb.getAttribute('data-srcset')) main.srcset = thumb.getAttribute('data-srcset'); else main.removeAttribute('srcset');
          thumbs.forEach(function (t) { t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false'); });
        });
      });
      function step(dir) {
        if (!thumbs.length) return;
        var current = 0;
        thumbs.forEach(function (t, i) { if (t.getAttribute('aria-pressed') === 'true') current = i; });
        var next = thumbs[(current + dir + thumbs.length) % thumbs.length];
        next.click();
        next.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      var prev = gallery.querySelector('[data-pai-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-pai-gallery-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    });
  }

  function init() {
    initLocalizeLinks();
    initReveal();
    initDrawer();
    initCtaTracking();
    initPlanPicker();
    initPlans();
    initGallery();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
